import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <TopicsSection />
        <CarouselSection />
        <FaqSection />
        <MediaSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <AppSection />
        <IndexSection />
        <RankingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}